import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {copyProperties, encodeParams, getAction} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';

// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool, searchCompany } from '@util/helper';

import moment from 'moment';
import {
  Avatar,
  Grid,
  Container,
} from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';

const Boxs = styled(Box)`
      padding-bottom: 40px !important;
    `;


const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ProfileEntrustPage = ({companyList}) => {
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'
  const fields = [
    {field: 'id', placeholder: '',    type:'text', value: -1, visible: false, canSrch: false, selList:[]},
    {field: 'name', placeholder: '이름',    type:'text', value:'', visible: true, canSrch: true, selList:[]},
    {field: 'statCode', placeholder: '',    type:'text', value: 'S001', visible: false, canSrch: false,selList:[]},
    {field: 'phone', placeholder: '전화', type:'number', value: '', visible: true, canSrch: true, selList:[]},
    {field: 'loginId', placeholder: '로그인ID', type:'text', value: '', visible: true, canSrch: false, selList:[]},
    {field: 'password', placeholder: '비밀번호', type:'text', value: '1', visible: false, canSrch: false, selList:[]},
    {field: 'phoneCertYn', placeholder: '폰인증여부', type:'text', value: 'N', visible: true, canSrch: false, selList:[]},
    {field: 'deviceToken', placeholder: '디바이스토큰', type:'text', value: '', visible: false, canSrch: false, selList:[]},
    {field: 'email', placeholder: '이메일', type:'text', value:'', visible: true, canSrch: false, selList:[]},
    {field: 'address', placeholder: '주소', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'address2', placeholder: '주소', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'zipCode', placeholder: '주소', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'regTime', placeholder: '등록일시', type:'text', value:'', visible: false, canSrch: false, selList:[]},
    {field: 'uptTime', placeholder: '수정일시', type:'text', value:'', visible: false, canSrch: false, selList:[]},
  ]

  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []  
  defRecord.schoolRltnList = []
  defRecord.companyRltnList = []
  
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const [companies, set_companies] = useState([])
  const [companySchoolRltnList, set_companySchoolRltnList] = useState([])
  const [entrustSchools, set_entrustSchools] = useState([])
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)

  
  const validate = () => {}
  
  const [schoolList, set_schoolList] = useState([])
  
  const navigate = useNavigate()
  useEffect(() => {
    const accountSchools = account.schoolRelationList.map(it => it.school)
    set_entrustSchools(accountSchools)
    onLoad()
  }, [])

  const onLoad = async() => {
    
    openIndicator()

    //
    let url = ''
    let resp = {}

    //
    url = '/common/company/school/rltn'
    resp = await WebService.get(url)

    if(resp.repCode === 'reject') {
      navigate('/login')
      return
    }

    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      set_companySchoolRltnList(records)
    }

    //
    url = '/company'
    resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      set_companies(records)
    }

    //
    url = `/user/rltn`
    resp = await WebService.get(url, {userId: account.user.id})
    
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const schoolRltnList = JSON.parse(repMessage.schoolRltnList)
      const companyRltnList = JSON.parse(repMessage.companyRltnList)
      activeRow.schoolRltnList = schoolRltnList
      activeRow.companyRltnList = companyRltnList
      handleChange()
    }

    
    closeIndicator()
  }


  const findCompany = (schoolId) => {
    const rltn = companySchoolRltnList.find(it => +it.schoolId === +schoolId)
    if(rltn) {
      const company = companies.find(it => +it.id === +rltn.companyId)
      if(company) {
        return company
      }
    }
    return undefined
  }
  
  const onSubmit = async () => {
    openSnackbar('개발 중...')
  }

  const [
    activeRow,
    errors,
    formLoading,
    handleChange,
    handleSubmit, 
   ] = useForm({
    initialValues: {...account, schoolRltnList:[], companyRltnList:[]}, 
    onSubmit: onSubmit,
    validate: validate,
  });

  const filterOptions = (options, state) => {
    let newOptions = []
    newOptions = options.filter(o => o.name.includes(state.inputValue)).slice(0, 10)
    return newOptions;
  };

   return (
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
        <Typography component="h1" variant="h5" align={'center'} gutterBottom={true}>
          My 위탁 학교
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Autocomplete
              disablePortal
              options={companyList}
              filterOptions={filterOptions}
              onInputChange={async (event, value, reason) => {
                if(reason === 'input') {
                  // const records = await searchSchool(value)
                  // set_schoolList(records)
                }
              }}
              onChange = {async (e, v)=> {
                const newSchools = [...entrustSchools]
                if(!newSchools.find(s => +s.schoolId === +v.id)) {
                  // entrustSchools.schoolRltnList.push({userId: activeRow.id, schoolId: v.id})
                  // set_record(newRecord)
                  newSchools.push(v)
                  set_entrustSchools(newSchools)
                }
                else {
                  openSnackbar('이미 같은 학교가 선택되어 있습니다.')
                }
              }}
              size='small'
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField  {...params} label="회사명" />}
            />
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              disablePortal
              options={schoolList}
              filterOptions={filterOptions}
              onInputChange={async (event, value, reason) => {
                if(reason === 'input') {
                  const records = await searchSchool(value)
                  set_schoolList(records)
                }
              }}
              onChange = {async (e, v)=> {
                const newSchools = [...entrustSchools]
                if(!newSchools.find(s => +s.schoolId === +v.id)) {
                  // entrustSchools.schoolRltnList.push({userId: activeRow.id, schoolId: v.id})
                  // set_record(newRecord)
                  newSchools.push(v)
                  set_entrustSchools(newSchools)
                }
                else {
                  openSnackbar('이미 같은 학교가 선택되어 있습니다.')
                }
              }}
              size='small'
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField  {...params} label="학교명" />}
            />
          </Grid>
        </Grid>







        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              disablePortal
              options={schoolList}
              filterOptions={filterOptions}
              onInputChange={async (event, value, reason) => {
                if(reason === 'input') {
                  const records = await searchSchool(value)
                  set_schoolList(records)
                }
              }}
              onChange = {async (e, v)=> {
                const newSchools = [...entrustSchools]
                if(!newSchools.find(s => +s.schoolId === +v.id)) {
                  // entrustSchools.schoolRltnList.push({userId: activeRow.id, schoolId: v.id})
                  // set_record(newRecord)
                  newSchools.push(v)
                  set_entrustSchools(newSchools)
                }
                else {
                  openSnackbar('이미 같은 학교가 선택되어 있습니다.')
                }
              }}
              size='small'
              sx={{ width: 300 }}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField  {...params} label="학교명" />}
            />
            <MUITable>
              <TableHead>
                <TableRow>
                  <TableCell>제거</TableCell>
                  <TableCell>학교</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  entrustSchools.map((it,index) => {
                    return(
                      <TableRow>
                        <TableCell>
                          <IconButton onClick={()=> {
                            const newSchools = [...entrustSchools]
                            const idx = newSchools.findIndex(r => +r.id === +it.id)
                            if(idx >= 0) {
                              newSchools.splice(idx, 1)
                              set_entrustSchools(newSchools)
                            }
                          }}>
                            <RemoveCircleOutlineIcon/>
                          </IconButton>
                        </TableCell>
                        
                        <TableCell>{it.name}</TableCell>
                      </TableRow>
                    )
                    
                  })
                }
              </TableBody>
            </MUITable>
          </Grid>
        </Grid>

        <Button variant='contained' color='primary' size='small' onClick={onSubmit} sx={{mt: 10, width:100}}>저장</Button>
      </Box>
      <div>
        {renderIndicator()}
      </div>
    </Container>
  );
}

export default ProfileEntrustPage
